import * as yup from "yup";

export const validation = yup.object().shape({
  cli_nombre: yup
    .string()
    .required("El nombre es obligatorio")
    .min(2, "Debe tener al menos 2 caracteres"),

  cli_apellido: yup
    .string()
    .required("El apellido es obligatorio")
    .min(2, "Debe tener al menos 2 caracteres"),

  cli_correo: yup
    .string()
    .email("Correo electrónico inválido")
    .required("El correo es obligatorio"),

  cli_telefono: yup
    .string()
    .required("El teléfono es obligatorio"),

  tipo_iva: yup
    .string()
    .required("El tipo de IVA es obligatorio"),

  cli_tipo_doc: yup
    .string()
    .required("El tipo de documento es obligatorio"),

  cli_nro_doc: yup
    .string()
    .required("El número de documento es obligatorio")
    .when("tipo_iva", {
      is: "Responsable Inscripto",
      then: schema =>
        schema.matches(/^\d{11}$/, "El CUIT debe tener 11 dígitos numéricos"),
      otherwise: schema =>
        schema.matches(/^\d{7,8}$/, "El DNI debe tener entre 7 y 8 dígitos"),
    }),

  cli_direccion: yup.string(),
  cli_numeracion: yup.string(),
  cli_piso: yup.string(),
  cli_dpto: yup.string(),
  cli_bloque: yup.string(),
  cli_localidad: yup.string(),
  cli_provincia: yup.string(),
  cli_cp: yup.string(),
  cli_dir_observacion: yup.string(),

  // Contraseña: lógica unidireccional basada en pass_new
  pass_new: yup.string().when([], {
    is: () => true, // no depende de nadie
    then: schema => schema.notRequired(),
  }),

  cli_pass: yup.string().when("pass_new", {
    is: (pass_new) => !!pass_new,
    then: schema => schema.required("La contraseña actual es obligatoria"),
    otherwise: schema => schema.notRequired(),
  }),

  pass_confirm: yup.string().when("pass_new", {
    is: (pass_new) => !!pass_new,
    then: schema =>
      schema
        .required("Debe confirmar la nueva contraseña")
        .oneOf([yup.ref("pass_new")], "Las contraseñas no coinciden"),
    otherwise: schema => schema.notRequired(),
  }),
});
